import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { sendGraph } from '@fiverr-private/futile';
import { addRecentInteraction } from '../API/recentInteractions';
import * as api from '../API';
import * as appNames from '../enums/apps';
import { mwAddRecentInteraction, mwMonitor } from './middleware';
import countReducer from './countReducer';
import itemReducer from './itemReducer';

const rootReducer = combineReducers({
    [appNames.APP_NAME_INBOX]: itemReducer(appNames.APP_NAME_INBOX),
    [appNames.APP_NAME_NOTIFICATIONS]: itemReducer(appNames.APP_NAME_NOTIFICATIONS),
    count: countReducer,
});

const composeEnhancers = (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

const store = createStore(
    rootReducer,
    {
        [appNames.APP_NAME_INBOX]: {},
        [appNames.APP_NAME_NOTIFICATIONS]: {},
        count: {},
    },
    composeEnhancers(
        applyMiddleware(
            thunk.withExtraArgument({ api }),
            mwAddRecentInteraction(addRecentInteraction),
            mwMonitor(sendGraph)
        )
    )
);

export default store;
